import { useEffect, useState } from 'preact/hooks'

const useMediaQuery = (query: string) => {
  const getMatches = (q: string) => window.matchMedia(q).matches

  const [matches, setMatches] = useState(getMatches(query))

  function handleChange() {
    setMatches(getMatches(query))
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query)

    handleChange()

    matchMedia.addEventListener('change', handleChange)

    return () => {
      matchMedia.removeEventListener('change', handleChange)
    }
  }, [])

  return matches
}

export default useMediaQuery
